function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Heading as ChakraHeading, NumberInput, NumberInputField, Select, Switch, Textarea, useDisclosure } from '@chakra-ui/react';
import { FormattedMessage, useIntl } from 'react-intl';
import { SongRequestPlaylist, SongRequestProvider, UserLevels } from '@/types/server';
import { useFormik } from 'formik';
import useChannelStore from '@/stores/ChannelStore';
import { getSongRequestSettings, updateSongRequestSettings } from '@/actions/SongRequestActions';
import DashboardLayout from '../layouts/DashboardLayout';
import Heading from '../Heading';
import { WebRoutes } from '@/utils/constants';
import { faSoundcloud, faYoutube } from '@fortawesome/free-brands-svg-icons';
import SettingsPanel from '../SettingsPanel';
import InputModal from '../InputModal';
import useNativeStore from '@/stores/NativeStore';
import useIsNative from '@/hooks/useIsNative';
import { Helmet } from 'react-helmet';
import useDebouncedCallbackOnChange from '@/hooks/useDebouncedCallbackOnChange';
import BackButton from '../BackButton';
import { useShallow } from 'zustand/react/shallow';
var DEFAULT_SETTINGS = {
    volume: 50,
    enabled: false,
    providers: [
        SongRequestProvider.YOUTUBE,
        SongRequestProvider.SOUNDCLOUD
    ],
    playlist: SongRequestPlaylist.CHANNEL,
    userLevel: UserLevels.EVERYONE,
    searchProvider: SongRequestProvider.YOUTUBE,
    youtube: {
        limitToMusic: false,
        limitToLikedVideos: false
    },
    limits: {
        queue: 20,
        user: 5,
        playlistOnly: false,
        exemptUserLevel: UserLevels.MODERATOR
    }
};
export default function SongRequestSettings() {
    var intl = useIntl();
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var _React_useState = _sliced_to_array(React.useState(null), 2), settings = _React_useState[0], setSettings = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(null), 2), providers = _React_useState1[0], setProviders = _React_useState1[1];
    var _React_useState2 = _sliced_to_array(React.useState(null), 2), playlists = _React_useState2[0], setPlaylists = _React_useState2[1];
    var resetDefaultModal = useDisclosure();
    var _useNativeStore = useNativeStore(useShallow(function(state) {
        return {
            currentSongOutputFormat: state.currentSongOutputFormat,
            setCurrentSongOutputFormat: state.setCurrentSongOutputFormat
        };
    })), currentSongOutputFormat = _useNativeStore.currentSongOutputFormat, setCurrentSongOutputFormat = _useNativeStore.setCurrentSongOutputFormat;
    var isNative = useIsNative();
    React.useEffect(function() {
        if ((channel === null || channel === void 0 ? void 0 : channel._id) == null) {
            return;
        }
        getSongRequestSettings(channel._id).then(function(param) {
            var settings = param.settings, providers = param.providers, playlists = param.playlists;
            var currentChannel = useChannelStore.getState().channel;
            if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel._id) !== channel._id) {
                return;
            }
            setSettings(settings);
            setProviders(providers);
            setPlaylists(playlists);
        });
    }, [
        channel === null || channel === void 0 ? void 0 : channel._id
    ]);
    var formik = useFormik({
        initialValues: DEFAULT_SETTINGS,
        validateOnChange: false,
        onSubmit: function(values) {
            if (channel == null) {
                return;
            }
            updateSongRequestSettings(channel._id, values).then(function() {
                return setSettings(values);
            }).catch(console.error);
        }
    });
    useDebouncedCallbackOnChange(formik, function() {
        if (!formik.dirty) {
            return;
        }
        formik.submitForm();
    });
    React.useEffect(function() {
        if (settings == null) {
            return;
        }
        formik.resetForm({
            values: settings
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        settings
    ]);
    var toggleSongProvider = React.useCallback(function(provider) {
        var hasProvider = formik.values.providers.includes(provider);
        if (hasProvider) {
            formik.setFieldValue('providers', formik.values.providers.filter(function(p) {
                return p !== provider;
            }));
        } else {
            formik.setFieldValue('providers', _to_consumable_array(formik.values.providers).concat([
                provider
            ]));
        }
    }, [
        formik
    ]);
    var _channel_userLevels, _channel_userLevels1;
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        containerProps: {
            maxW: 'container.lg'
        },
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "tIx4iB",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Song Request Settings"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(BackButton, {
                fallbackParams: WebRoutes.SONG_REQUESTS,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "3s3LJl",
                    defaultMessage: "Song Requests"
                })
            }),
            /*#__PURE__*/ _jsx(ChakraHeading, {
                size: "sm",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "tIx4iB",
                    defaultMessage: "Song Request Settings"
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                heading: intl.formatMessage({
                    id: "ix27PQ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Youtube"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "1TRxVz",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enable Song Requests from Youtube"
                        }
                    ]
                }),
                icon: faYoutube,
                afterElement: /*#__PURE__*/ _jsx(Switch, {
                    name: "providers",
                    isChecked: formik.values.providers.includes(SongRequestProvider.YOUTUBE),
                    onChange: function() {
                        return toggleSongProvider(SongRequestProvider.YOUTUBE);
                    },
                    colorScheme: "primary"
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                heading: intl.formatMessage({
                    id: "whn22Z",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "SoundCloud"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "+SeTwr",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enable Song Requests from SoundCloud"
                        }
                    ]
                }),
                icon: faSoundcloud,
                afterElement: /*#__PURE__*/ _jsx(Switch, {
                    name: "providers",
                    isChecked: formik.values.providers.includes(SongRequestProvider.SOUNDCLOUD),
                    onChange: function() {
                        return toggleSongProvider(SongRequestProvider.SOUNDCLOUD);
                    },
                    colorScheme: "primary"
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                heading: intl.formatMessage({
                    id: "v5LyYx",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Fallback Playlist"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "PrRXGH",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Select the playlist that will be used when the queue is empty"
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsx(Select, {
                    name: "playlist",
                    value: formik.values.playlist,
                    onChange: formik.handleChange,
                    children: Object.entries(playlists !== null && playlists !== void 0 ? playlists : []).map(function(param) {
                        var _param = _sliced_to_array(param, 2), key = _param[0], playlist = _param[1];
                        return /*#__PURE__*/ _jsx("option", {
                            value: key,
                            children: playlist
                        }, key);
                    })
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                heading: intl.formatMessage({
                    id: "LEFJvP",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Minimum User-Level"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "Fc/RbL",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Select the minimum user-level required to request songs"
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsx(Select, {
                    name: "userLevel",
                    value: formik.values.userLevel,
                    onChange: formik.handleChange,
                    children: Object.entries((_channel_userLevels = channel === null || channel === void 0 ? void 0 : channel.userLevels) !== null && _channel_userLevels !== void 0 ? _channel_userLevels : []).map(function(param) {
                        var _param = _sliced_to_array(param, 2), key = _param[0], userLevel = _param[1];
                        return /*#__PURE__*/ _jsx("option", {
                            value: key,
                            children: userLevel
                        }, key);
                    })
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                heading: intl.formatMessage({
                    id: "mwq7TK",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Default Search Provider"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "1BHj5P",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Select the default search provider for song requests"
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsx(Select, {
                    name: "searchProvider",
                    value: formik.values.searchProvider,
                    onChange: formik.handleChange,
                    children: Object.entries(providers !== null && providers !== void 0 ? providers : []).map(function(param) {
                        var _param = _sliced_to_array(param, 2), key = _param[0], provider = _param[1];
                        return /*#__PURE__*/ _jsx("option", {
                            value: key,
                            children: provider
                        }, key);
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Heading, {
                size: "sm",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "TDrunp",
                    defaultMessage: "Limits"
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                heading: intl.formatMessage({
                    id: "6WdAnY",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Queue Limit"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "eUEai0",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "The maximum number of songs that can be queued"
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsx(NumberInput, {
                    defaultValue: 100,
                    min: 1,
                    name: "limits.queue",
                    value: formik.values.limits.queue,
                    onChange: function(_, value) {
                        return formik.setFieldValue('limits.queue', isNaN(value) ? 0 : value);
                    },
                    children: /*#__PURE__*/ _jsx(NumberInputField, {})
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                heading: intl.formatMessage({
                    id: "yjEVbr",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "User Request Limit"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "OeFjaT",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "The maximum number of songs a user can queue"
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsx(NumberInput, {
                    defaultValue: 100,
                    min: 1,
                    name: "limits.user",
                    value: formik.values.limits.user,
                    onChange: function(_, value) {
                        return formik.setFieldValue('limits.user', isNaN(value) ? 0 : value);
                    },
                    children: /*#__PURE__*/ _jsx(NumberInputField, {})
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                heading: intl.formatMessage({
                    id: "gGcLzi",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Playlist Only"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "fRPEYo",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Only allow songs from the fallback playlist"
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsx(Switch, {
                    name: "limits.playlistOnly",
                    isChecked: formik.values.limits.playlistOnly,
                    onChange: formik.handleChange,
                    colorScheme: "primary"
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                heading: intl.formatMessage({
                    id: "m1gaLD",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Exempt User-Level"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "H2NHTL",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Select the user-level that is exempt from limits"
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsx(Select, {
                    name: "limits.exemptUserLevel",
                    value: formik.values.limits.exemptUserLevel,
                    onChange: formik.handleChange,
                    children: Object.entries((_channel_userLevels1 = channel === null || channel === void 0 ? void 0 : channel.userLevels) !== null && _channel_userLevels1 !== void 0 ? _channel_userLevels1 : []).map(function(param) {
                        var _param = _sliced_to_array(param, 2), key = _param[0], userLevel = _param[1];
                        return /*#__PURE__*/ _jsx("option", {
                            value: key,
                            children: userLevel
                        }, key);
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Heading, {
                size: "sm",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "ix27PQ",
                    defaultMessage: "Youtube"
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                heading: intl.formatMessage({
                    id: "YDh89U",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Limit to Music"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "L5ioCs",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Only allow music videos to be requested"
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsx(Switch, {
                    name: "youtube.limitToMusic",
                    isChecked: formik.values.youtube.limitToMusic,
                    onChange: formik.handleChange,
                    colorScheme: "primary"
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                heading: intl.formatMessage({
                    id: "lPgPjM",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Limit to Liked Videos"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "sBNo3M",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Only allow videos with more likes than dislikes."
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsx(Switch, {
                    name: "youtube.limitToLikedVideos",
                    isChecked: formik.values.youtube.limitToLikedVideos,
                    onChange: formik.handleChange,
                    colorScheme: "primary"
                })
            }),
            isNative ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        size: "sm",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "k0MS8f",
                            defaultMessage: "Nightbot App"
                        })
                    }),
                    /*#__PURE__*/ _jsx(SettingsPanel, {
                        heading: intl.formatMessage({
                            id: "MYjhjL",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Output File"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "3hvHd5",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Automatically write song details to a text file for use in OBS."
                                }
                            ]
                        }),
                        afterElement: /*#__PURE__*/ _jsx(Textarea, {
                            placeholder: "{{title}} - {{artist}}",
                            value: currentSongOutputFormat !== null && currentSongOutputFormat !== void 0 ? currentSongOutputFormat : '',
                            onChange: function(param) {
                                var value = param.target.value;
                                return setCurrentSongOutputFormat(value);
                            }
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: resetDefaultModal.isOpen,
                onClose: resetDefaultModal.onClose,
                title: intl.formatMessage({
                    id: "ZGgOeV",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Reset to Default"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "uFq6Ic",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Are you sure you want to reset your song request settings to the default values?"
                        }
                    ]
                }),
                onSubmit: function() {
                    formik.setValues(DEFAULT_SETTINGS);
                    resetDefaultModal.onClose();
                },
                submitText: intl.formatMessage({
                    id: "jm/spn",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Reset"
                        }
                    ]
                })
            })
        ]
    });
}
